// src/config/dev-host.ts
//
// Is this page served from a DEV host? The allowlist is the hosts this app is actually served from
// in development: the local Vite server, and the deployed dev site (`dev-practitioner-v2.scrips.com`,
// .github/workflows/dev-web.yml). Everything else — qa, uat, prod, any unknown host — is NOT dev.
//
// Why the hostname and not `import.meta.env.DEV`: the deployed dev site is a production build
// (DEV is false there — the trap `auth/dev-auto-login.ts` documents), and a dev-only TOOL has to
// work on it. Why not the API base URL: a build is one artefact that could be served from another
// host; what the person is looking at is the host. Fails CLOSED: no window → not dev.

export const DEV_HOSTS: readonly string[] = ['localhost', '127.0.0.1', 'dev-practitioner-v2.scrips.com'];

export function isDevHost(hostname: string | undefined = typeof window === 'undefined' ? undefined : window.location.hostname): boolean {
  return !!hostname && DEV_HOSTS.includes(hostname.toLowerCase());
}
